import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { BudgetLabel } from '@/api/budgets';
import { OrganizationDto } from '@/api/organizations';
import { useCurrentOrganizationStore } from '@/store/use-current-organization-store';

export type BudgetPlacement = {
  hasCoOpBudgets: boolean;
  hasStoreBudgets: boolean;
  isCoOpBudgetsInPromote: boolean;
  coOpExcludedBudgetTypes: BudgetLabel[] | undefined;
};

type BudgetPlacementOrganization = Readonly<
  Pick<
    OrganizationDto,
    | 'isBusinessesEnabled'
    | 'isCoOp'
    | 'isPrintEnabled'
    | 'hasPrintBudgets'
    | 'isPromoteEnabled'
  >
>;

export const getBudgetPlacement = (
  organization: BudgetPlacementOrganization | null | undefined,
): BudgetPlacement => {
  const isBusinessesEnabled = Boolean(organization?.isBusinessesEnabled);
  const isCoOp = Boolean(organization?.isCoOp);

  const hasCoOpBudgets = isBusinessesEnabled && isCoOp;
  const hasStoreBudgets =
    isBusinessesEnabled &&
    Boolean(organization?.isPrintEnabled) &&
    (isCoOp || Boolean(organization?.hasPrintBudgets));

  return {
    hasCoOpBudgets,
    hasStoreBudgets,
    isCoOpBudgetsInPromote:
      hasCoOpBudgets && Boolean(organization?.isPromoteEnabled),
    coOpExcludedBudgetTypes: hasStoreBudgets ? [BudgetLabel.PRINT] : undefined,
  };
};

export const useOrganizationBudgets = () => {
  const { currentOrganization } = storeToRefs(useCurrentOrganizationStore());

  return computed(() => getBudgetPlacement(currentOrganization.value));
};
